import { Navigate } from "react-router-dom";
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = () => {
    const token = localStorage.getItem("token");
    console.log(`${token}`);
    if (token && token !== "null") return true;
    else return false;
  };

  if (!isAuthenticated()) {
    return <Navigate to="/account/login/" replace />;
  }

  return children;
};

export default ProtectedRoute;
